<script setup>
import { computed } from 'vue'

const props = defineProps({
  data: [Array, Object],
})
const isRight = computed(() => {
  return props.data.position_bearing < 180
})
</script>

<template>
  <div :style="`--rotation: ${data.position_bearing}deg;`">
    <svg
      width="120"
      height="44"
      viewBox="0 0 72 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <!-- Rectangle -->
      <rect
        x="15"
        y="11"
        width="53"
        height="28"
        fill="#F7CB32"
      />

      <!-- Paths -->
      <path
        v-if="isRight"
        d="M84 25 L70.25 17 L70.25 33 L86 24 Z"
        fill="#09262D"
      />

      <path
        v-else
        d="M0 25 L12.75 17 L12.75 33 L0 25 Z"
        fill="#09262D"
      />
      <!-- Text for the dynamic number -->
      <text
        :x="!isRight ? 40 : 26"
        :y="!isRight ? 30 : 23"
        text-anchor="middle"
        font-weight="bold"
        font-size="15"
        fill="black"
        :style="!isRight ? '' : 'transform: rotate(180deg); transform-origin: center;'"
      >
        {{ data.route_short_name }}
      </text>
    </svg>
  </div>
</template>

<style scoped>
.transform {
  transform: rotate(var(--rotation, 0deg));
}
</style>
